import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import Layout from "../../components/layout/Layout";

export default function ViewCancel() {
    const location = useLocation();
    const data = location.state.data;

    const navigate = useNavigate();

    const [loading, setLoading] = useState(false);

    function formatDate(isoDateStr) {
        const date = new Date(isoDateStr);

        const options = {
            day: "2-digit",
            month: "short",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
        };

        return date.toLocaleString("en-IN", options).replace(",", "");
    }

    return (
        <div>
            <Layout>
                <div className="bg-white md:p-10 p-3 rounded-xl shadow-md mt-8">
                    <div className="flex justify-between items-center">
                        <h2 className="text-xl font-medium">View Order</h2>
                    </div>
                    <div className="mt-10">
                        <div className="flex my-6">
                            <div className="w-1/2">
                                <h6 className="text-sm font-medium">Order Id</h6>
                                <p className="mt-1">{data?.orderId}</p>
                            </div>
                            <div className="w-1/2">
                                <h6 className="text-sm font-medium">Contact Number</h6>
                                <p className="mt-1">{data?.user.phone}</p>
                            </div>
                        </div>
                        <hr />

                        <div className="flex my-6">
                            <div className="w-1/2">
                                <h6 className="text-sm font-medium">Requested At</h6>
                                <p className="mt-1">{formatDate(data?.requestedAt)}</p>
                            </div>
                            <div className="w-1/2">
                                <h6 className="text-sm font-medium">Approved At</h6>
                                <p className="mt-1">{data?.completedAt ? formatDate(data?.completedAt) : ""}</p>
                            </div>
                        </div>
                        <hr />
                        <div className="flex my-6">
                            <div className="w-1/2">
                                <h6 className="text-sm font-medium">Reason</h6>
                                <p className="mt-1">{data.reason}</p>
                            </div>
                            <div className="w-1/2">
                                <h6 className="text-sm font-medium">Order Cancel Status</h6>
                                <p className="mt-1">{data.status}</p>
                            </div>
                        </div>

                        <div className="flex my-6">
                            <div className="">
                                <h6 className="text-sm font-medium">Cancellation Summary</h6>
                                <ul className="mt-1 space-y-2">
                                    {Array.isArray(data?.cancelhistories) && data.cancelhistories.length > 0 ? (
                                        <ul className="space-y-2">
                                            {data.cancelhistories?.map((r) => {
                                                const dateObj = new Date(r.requestedAt);
                                                const formattedDate = isNaN(dateObj.getTime())
                                                    ? "No replies yet"
                                                    : dateObj.toLocaleString("en-IN", {
                                                        day: "2-digit",
                                                        month: "2-digit",
                                                        year: "numeric",
                                                        hour: "2-digit",
                                                        minute: "2-digit",
                                                        hour12: true,
                                                    });

                                                return (
                                                    <li key={r._id} className="border-b pb-1">
                                                        <p className="text-gray-800">{r.status}</p>
                                                        <span className="text-xs text-gray-500">{formattedDate}</span>
                                                    </li>
                                                );
                                            })}
                                        </ul>
                                    ) : (
                                        <p className="text-gray-500 text-sm">No remarks yet.</p>
                                    )}

                                </ul>
                            </div>
                        </div>

                    </div>
                </div>
            </Layout>
        </div>
    );
}
